const mediaItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Entertainment%20news%20studio%20set%2C%20professional%20broadcast%20lighting%2C%20warm%20modern%20aesthetic%2C%20sleek%20desk%20and%20screen%20setup%2C%20TV%20studio%20atmosphere%2C%20professional%20media%20production%2C%20clean%20minimal%20background&width=800&height=480&seq=media-01&orientation=landscape',
    title: '911吃瓜周报 Vol.42：本周最火的十个瓜',
    duration: '15:28',
    views: '12.8万',
    alt: '911吃瓜网视频周报',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20film%20production%2C%20camera%20equipment%20and%20crew%2C%20warm%20cinematic%20lighting%2C%20professional%20videography%2C%20golden%20hour%20on%20set%2C%20editorial%20style&width=800&height=480&seq=media-02&orientation=landscape',
    title: '独家探班：某热播剧拍摄现场的瓜',
    duration: '08:42',
    views: '9.6万',
    alt: '911吃瓜网独家探班视频',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Live%20streaming%20setup%20for%20entertainment%20show%2C%20modern%20studio%20with%20ring%20lights%2C%20warm%20vibrant%20atmosphere%2C%20professional%20streaming%20equipment%2C%20dynamic%20energy%2C%20clean%20neutral%20background&width=800&height=480&seq=media-03&orientation=landscape',
    title: '吃瓜直播间：实时追踪令粉丝破防的瞬间',
    duration: '22:15',
    views: '18.3万',
    alt: '911吃瓜网直播追踪视频',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Celebrity%20interview%20setting%2C%20intimate%20warm%20lighting%2C%20comfortable%20elegant%20seating%2C%20professional%20recording%20equipment%2C%20magazine%20interview%20atmosphere%2C%20editorial%20quality%2C%20simple%20backdrop&width=800&height=480&seq=media-04&orientation=landscape',
    title: '业内人士访谈：娱乐圈公关套路全解析',
    duration: '18:50',
    views: '7.2万',
    alt: '911吃瓜网业内人士访谈视频',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Entertainment%20variety%20show%20production%2C%20colorful%20studio%20set%2C%20warm%20vibrant%20lighting%2C%20professional%20TV%20production%2C%20dynamic%20show%20atmosphere%2C%20editorial%20photography&width=800&height=480&seq=media-05&orientation=landscape',
    title: '综艺名场面Reaction：嘉宾表情管理失败时刻',
    duration: '11:33',
    views: '21.5万',
    alt: '911吃瓜网综艺名场面视频',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-1 h-6 bg-accent-500 rounded-full"></span>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">视频专区</h2>
          <span className="text-xs text-foreground-400">热门视频精选</span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <a
              key={item.title}
              href="#media"
              className="group block rounded-xl overflow-hidden border border-background-200/70 bg-background-50 hover:border-accent-200 transition-colors cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/10 group-hover:bg-black/20 transition-colors"></div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/70 text-white text-[10px] font-medium">
                  {item.duration}
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-primary-600 text-xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm font-medium text-foreground-800 group-hover:text-accent-700 transition-colors line-clamp-2 mb-1.5">
                  {item.title}
                </h3>
                <span className="text-xs text-foreground-400">{item.views} 次播放</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}